import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-fares',
  templateUrl: './fares.component.html',
  styleUrls: ['./fares.component.css']
})
export class FaresComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
